import { jsx as x } from "react/jsx-runtime";
import { forwardRef as f, useContext as h } from "react";
import { Checkbox as i } from "./Checkbox.js";
import { Context as p } from "./context.js";
const C = f(
  ({ value: e, indeterminate: o, children: r, ...t }, n) => {
    const { name: a, value: c, onChange: m, error: d, errorIds: s } = h(p);
    return /* @__PURE__ */ x(
      i,
      {
        ref: n,
        name: a,
        value: e,
        checked: c.includes(e),
        indeterminate: o,
        onChange: m,
        error: d,
        errorIds: s,
        ...t,
        children: r
      }
    );
  }
);
C.displayName = "ManagedCheckbox";
export {
  C as ManagedCheckbox
};
//# sourceMappingURL=ManagedCheckbox.js.map
